import styled from "@emotion/styled";
import { Container } from "@mui/material"; 
import React from "react";
import {
  SectionHeading,
  SectionSmallHeading,
  SectionWrapper,
} from "../../../styles";

const Div = styled.div`
  display: flex;
  justify-content: center;
  padding: 0px 0px 0px 0px;
`;
const DivBG = styled.div`
  background-image: url("/images/apebg.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  @media screen and (max-width: 599px) {
    background-position: right;
    background-repeat: no-repeat;
    -webkit-background-size: cover;
    background-size: cover;
  }
`;
const ReadMore = styled.a`
  text-decoration: none;
  cursor: pointer;
  background-color: ${(props) => (props.bgcolor ? props.bgcolor : "#fff")};
  color: ${(props) => (props.color ? props.color : "#000")};
  border: ${(props) => (props.border ? props.border : "1px solid #fff")};
  margin-right: 20px;
  border-radius: 10px;
  padding: 8px 40px;
  font-family: "Poppins-Regular";
  font-size: 14px;
  @media screen and (max-width: 899px) {
    padding: 10px 30px;
  }
  @media screen and (max-width: 599px) {
    font-size: 12px;
    padding: 5px 10px;
    margin-right: 10px;
  }

  /* box-shadow: ${(props) =>
    props.bs ? props.bs : "inset 0px 2px 5px 0px #FED0AE"}; */
  &:hover {
    opacity: 0.9;
  }
`;

const index = () => {
  return (
    <Div id="socials">
      <Container maxWidth="xl">
        <DivBG>
          <SectionWrapper
            p1050="110px 20px"
            p900="60px 20px"
            p599="50px 20px"
            p="110px 20px"
            data-aos="fade-zoom-in"
            data-aos-easing="ease-in"
            // data-aos-delay="500"
            // data-aos-offset="0"
            data-aos-duration="1500"
          >
            <SectionSmallHeading>Join The Community </SectionSmallHeading>
            <div style={{ paddingTop: "50px" }}>
              <ReadMore
                color="#fff"
                bgcolor="#004F64"
                href="https://twitter.com/ProofofApeETH"
                target="_blank"
              >
                Twitter
              </ReadMore>
              <ReadMore
                color="#fff"
                bgcolor="#004F64"
                href="https://t.me/proofofape"
                target="_blank"
              >
                Telegram
              </ReadMore>
              <ReadMore
                color="#fff"
                bgcolor="#004F64"
                href="https://medium.com/@zaffre_73091/apecoin-2-0-4d3abad58339"
                target="_blank"
              >
                Medium
              </ReadMore>
            </div>
            {/* <Image
          src="/images/join.png"
          width="1920"
          height="623"
          layout="intrinsic"
        /> */}
          </SectionWrapper>
        </DivBG>
      </Container>
    </Div>
  );
};

export default index;
